<template>
  <div class="news_container">
    <div v-for="(item, index) of content" :key="index" class="news_item">
      <div :class="'title ' + item.Sentiment">
        <span style="vertical-align: middle;margin-left: 5px;"><el-link :underline="false" :href="item.Url"
            target="_blank">{{ item.Title
            }}</el-link></span>
      </div>
      <div class="content">{{ item.Content }}</div>
      <div class="buttom">
        <div class="stock">{{ item.StockName.split(" ").slice(0, 5).join(" ") }} </div>
        <div class="time">{{ item.ReleaseTime }}</div>
        <div class="expend"></div>
        <div class="source">来源:{{ item.WebName }}</div>
      </div>
      <div class="divider" v-if="index !== content.length - 1" />
    </div>

  </div>
</template>

<script>
// import Editor from '@tinymce/tinymce-vue'
// // import Highcharts from 'highcharts/highstock';
// // import HighchartsMore from 'highcharts/highcharts-more';
// import * as echarts from 'echarts';
import kChart from './KLine/index.vue';

export default {
  props: ['content'],
  data () {
    return {

    }
  },
  methods: {

  },
  components: {
    kChart
  },
  mounted () {

  },
  watch: {

  }
}
</script>
<style lang="less" scoped>
.news_container::-webkit-scrollbar {
  width: 5px;
  height: 100px;
  background-color: white;
}

.news_container::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30px;
  background-color: #e3eaff;
  border-radius: 5px;
}

.news_container {
  height: 500px;
  overflow-y: auto;

  .news_item {
    margin-top: 3px;

    .content {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      height: 46px;
      color: #888;
      font-size: 12px;
      padding: 5px;
    }

    .title {
      font-weight: bolder;
      color: #333;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      height: 24px;
    }

    .title::before {
      color: white;
      font-size: 12px;
      padding: 2px 3px;
      border-radius: 0px 5px 5px 5px;
      vertical-align: middle;
    }

    .中性::before {
      content: '中性';
      display: inline-block;
      background: linear-gradient(to right, #8cea87, #00ca00);
    }

    .正面::before {
      content: '正面';
      display: inline-block;
      background: linear-gradient(to right, #0000f552, #1414ff);
    }

    .负面::before {
      content: '负面';
      display: inline-block;
      background: linear-gradient(to right, #ffa5005e, orange);
    }

    .buttom {
      display: flex;
      font-size: 12px;
      padding: 5px 1px;
      color: #999;
      vertical-align: middle;

      .stock {
        flex-grow: 0;
        background-color: #00000029;
        color: rgb(117, 141, 255);
        border-radius: 2px;
        padding: 2px 3px;
        vertical-align: middle;
      }

      .time {
        flex-grow: 0;
        vertical-align: middle;
        padding: 2px 5px;
      }

      .expend {
        flex-grow: 1;
      }

      .source {
        flex-grow: 0;
        vertical-align: middle;
      }
    }

    .divider {
      border-bottom: 1px solid #999;
      margin: 5px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/chart/news.vue